// import { Button } from "bootstrap";
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { ThemeContext } from "../../../context/ThemeContext";
import { useContext } from "react";
import { Table, Pagination } from "rsuite";

import useTitle from "../../../hooks/useTitle";

// import { useGetOilInReportMutation } from "../../../features/generator/generatorReportApi";
import { useGetBoilerListQuery } from "../../../features/boiler/boilerDataLogApi";
import { useBoilerOperatingReportMutation } from "../../../features/boiler/boilerOperatingReportApi";
import "./style.css";

const { Column, HeaderCell, Cell } = Table;

function BoilerOperatingReport() {
  useTitle("Boiler Operating Report");
  const theme = useContext(ThemeContext);
  const [formData, setFormData] = useState({});
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [dateWiseData, setDateWiseData] = useState([]);
  const [totalData, setTotalData] = useState({});

  const [tableLoading, setTableLoading] = useState(true);

  // const [getOilInReport, { isLoading: dateWiseLoading }] =
  //   useGetOilInReportMutation();

  const [boilerOperatingReport, { isLoading: dateWiseLoading }] =
    useBoilerOperatingReportMutation();
  // const { data: generatorListResponse, isLoading: generatorListLoading } =
  //   useGetGeneratorListQuery();

  const { data: boilerList } = useGetBoilerListQuery();

  useEffect(() => {
    boilerOperatingReport()
      .unwrap()
      .then((payload) => {
        setDateWiseData(payload.data);
        setTotalData({
          total_duration_time: payload?.total_duration_time,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  useEffect(() => {
    if (!dateWiseLoading) {
      setTableLoading(false);
    }
  }, [dateWiseLoading]);

  let defaultData = [];
  let data = [];

  if (!dateWiseLoading) {
    defaultData = dateWiseData?.map((alertInfo) => {
      const data = new Date(alertInfo.updated_at);
      const formattedDate = data.toLocaleString();
      return {
        ...alertInfo,
        updated_at: formattedDate,
      };
    });

    // data = defaultData?.filter((v, i) => {
    //   const start = limit * (page - 1);
    //   const end = start + limit;
    //   return i >= start && i < end;
    // });

    data = [...defaultData];
  }

  const dataChangeHandler = (e) => {
    if (e.target.value == "") {
      delete formData[e.target.name];
    } else {
      setFormData((previousValue) => ({
        ...previousValue,
        [e.target.name]: e.target.value,
      }));
    }
  };
  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };

  const searchSumbitHandler = (e) => {
    e.preventDefault();
    setPage(1);
    console.log(formData);
    boilerOperatingReport(formData)
      .unwrap()
      .then((payload) => {
        setDateWiseData(payload.data);
        setTotalData({
          total_duration_time: payload?.total_duration_time,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const totalRow = {
    name: "Total ",
    duration: `Total Duration : ${totalData?.total_duration_time}`,
  };
  const columns = [
    {
      name: "name",
      title: "Boiler Name",
    },
    {
      name: "startdate",
      title: "Start Date",
    },
    {
      name: "enddate",
      title: "End Date",
    },
    {
      name: "duration",
      title: "Duration",
    },
  ];

  // const downloadCSVHandler = (e) => {
  //   e.preventDefault();
  //   const baseUrl = process.env.REACT_APP_API_URL + "/apiV2";
  //   const exportURL = `${baseUrl}/generator/oil-consumption-pdf`;
  //   if (formData?.startdate && formData?.combined_id) {
  //     const exportUrlWithDate =
  //       exportURL +
  //       `?startdate=${formData?.startdate}&enddate=${formData?.enddate}&combined_id=${formData?.combined_id}`;
  //     window.location.replace(exportUrlWithDate);
  //   } else if (formData?.startdate) {
  //     const exportUrlWithDate =
  //       exportURL +
  //       `?startdate=${formData?.startdate}&enddate=${formData?.enddate}`;
  //     window.location.replace(exportUrlWithDate);
  //   } else {
  //     window.location.replace(exportURL);
  //   }
  // };

  return (
    <div className={` ${theme} `}>
      <div
        className="theme-text"
        style={{ fontSize: "20px", fontWeight: "bold", paddingBottom: "1rem" }}
      >
        Boiler Operating Report
      </div>
      <div
        className="col-md-10"
        style={{ marginLeft: "-10px", marginBottom: "1rem" }}
      >
        <form onSubmit={(e) => searchSumbitHandler(e)}>
          <div className="row">
            <div className="form-group col-md-2">
              <label className="theme-text">Start Date </label>
              <input
                type="datetime-local"
                className="form-control"
                name="startdate"
                onChange={dataChangeHandler}
                required
              />
            </div>
            <div class="form-group col-md-2">
              <label className="theme-text">End Date</label>
              <input
                type="datetime-local"
                class="form-control"
                name="enddate"
                onChange={dataChangeHandler}
                required
              />
            </div>
            <div className="col-md-2 date-search-submit-btn">
              <select
                className="form-select"
                aria-label="Default select example"
                name="unique_id"
                onChange={dataChangeHandler}
              >
                <option value="" selected>
                  Select Boiler
                </option>
                {boilerList?.data?.map((boilerInfo) => {
                  return (
                    <option value={boilerInfo?.id}>{boilerInfo?.name}</option>
                  );
                })}
              </select>
            </div>
            <div className="col-md-2 date-search-submit-btn">
              <button type="submit" class="btn btn-primary col-md-12">
                Submit
              </button>
            </div>
            {/* <div className="col-md-2 date-search-submit-btn">
              <button
                class="btn btn-info col-md-12"
                onClick={downloadCSVHandler}
              >
                Export Pdf
              </button>
            </div> */}
          </div>
        </form>
      </div>

      <div className="theme-background theme-text">
        <div className="table-responsive theme-background theme-text">
          <Table height={500} data={[...data]} virtualized>
            {columns.map((column) => (
              <Column
                key={column.name}
                width={100}
                // resizable
                align="center"
                flexGrow={1}
                fullText
              >
                <HeaderCell>{column.title}</HeaderCell>
                <Cell dataKey={column.name} />
              </Column>
            ))}
          </Table>
          <div className="total-row" style={{ background: "transparent" }}>
            {columns.map((column) => (
              <div
                key={column.name}
                className="total-cell theme-background theme-text center-text"
                style={{
                  width: "200px",
                  border: "none",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {column.name === "name" ? "Total" : totalRow[column.name]}
              </div>
            ))}
          </div>
          {/* <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="lg"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={defaultData?.length}
              limitOptions={[10, 30, 50, 100, 200]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default BoilerOperatingReport;
